export default __webpack_public_path__ + "static/media/project_uncontracted.cdde4daf.svg";